//Attentive Events
window.addEventListener("variant:changed", async (evt) => {
  await attentiveProductView(evt);
});

window.addEventListener("product:viewed", async (evt) => {
  await attentiveProductView(evt)
  setTimeout(() => {
    if(window.trynow){
      window.trynow.reset()
      window.trynow.components.ctaButton.setProduct(window.trynow.components.ctaButton.product)
      window.trynow.components.ctaButton.setSelectedVariantId(evt.detail.variant.id)
    }
  }, 1000)
});

window.addEventListener("cart:updated", async (evt) => {
  await attentiveUpdateCart(evt.detail.cart);
});

async function attentiveUpdateCart(cart) {
  const attentive = await waitForVariable("attentive");
  if (!attentive) return;

  const data = {
    items: cart.items.map((item) => generateAttentiveItem(item)),
    cart: {
      cartId: cart.token,
    },
  };

  attentive.analytics.cartUpdated(data);
}

async function attentiveAddToCart(item, cart) {
  const attentive = await waitForVariable("attentive");
  if (!attentive) return;

  const data = {
    items: [generateAttentiveItem(item)],
    cart: {
      cartId: cart.token,
    },
  };

  attentive.analytics.addToCart(data);
}

let viewingVariant = null;

async function attentiveProductView(evt) {
  if (viewingVariant === evt.detail.variant?.id) return;

  viewingVariant = evt.detail.variant?.id;

  const attentive = await waitForVariable("attentive");
  if (!attentive) return;

  const data = {
    items: [
      {
        productId: evt.detail.product.id,
        productVariantId: evt.detail.variant?.id,
        name: evt.detail.variant?.name || evt.detail.product.title,
        productImage: evt.detail.product.featured_image,
        category: evt.detail.product.type,
        price: {
          value: (evt.detail.variant?.price || evt.detail.product.price) / 100,
          currency: Shopify.currency.active,
        },
        quantity: 1,
      },
    ],
  };

  attentive.analytics.productView(data);
}

function generateAttentiveItem(item) {
  return {
    productId: item.product_id,
    productVariantId: item.id,
    name: item.title,
    productImage: item.image,
    price: {
      value: item.original_price / 100,
      currency: Shopify.currency.active,
    },
    quantity: 1,
  };
}

function waitForVariable(variableName, checkInterval = 300, maxTries = 400) {
  console.log(`Waiting for ${variableName} to be available`);
  return new Promise((resolve, reject) => {
    if (typeof variableName !== "string" || !variableName) {
      reject(new Error("Invalid variable name"));
      return;
    }

    let tries = 0;

    const checkVariable = () => {
      tries++;
      if (window[variableName] !== undefined) {
        resolve(window[variableName]);
      } else if (tries >= maxTries) {
        reject(
          new Error(
            `Variable ${variableName} not found within ${maxTries} tries`
          )
        );
      } else {
        setTimeout(checkVariable, checkInterval);
      }
    };

    checkVariable();
  });
}

// ---
// Cards
class SectionCards extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 2.05,
      spaceBetween: 8,
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  }
}

customElements.define("section-cards", SectionCards);
// End Cards
// ---

// ---
// Testimonials
class Testimonials2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1.3,
      spaceBetween: 16,
      breakpoints: {
        767: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
      },
    });
  }
}

customElements.define("testimonials-2", Testimonials2);
// End Testimonials
// ---

// ---
// FAQ Section
class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.handleQuestions();
  }

  handleQuestions() {
    const $questionTogglers = this.querySelectorAll(
      ".faq__content-item-question-button"
    );
    $questionTogglers.forEach(($questionToggler) => {
      $questionToggler.addEventListener("click", () => {
        const $questionItem = $questionToggler.closest(
          ".faq__content-item-question"
        );
        $questionItem.classList.toggle("active");
      });
    });
  }
}

customElements.define("faq-section", FaqSection);
// End FAQ Section
// ---

// ---
// Quick Buy Button
class QuickBuyButton extends HTMLElement {
  quickBuyModalHTML = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.generateButton();
  }

  generateButton() {
    const $btn = document.createElement("button");
    $btn.classList.add("btn", "quick-buy-button");
    $btn.type = "button";
    $btn.innerText = this.innerText;

    $btn.addEventListener("click", async () => {
      try {
        $btn.classList.add("is-processing");
        await this.openQuickBuyModal();
      } catch (ex) {
        console.error(ex);
      } finally {
        $btn.classList.remove("is-processing");
      }
    });

    this.innerHTML = "";
    this.appendChild($btn);
  }

  async fetchQuickBuyModalHTML() {
    let link = this.getAttribute("data-product-url");
    if (!link) {
      console.error("No data-product-url attribute set");
      return;
    }

    const quickBuyTemplateQueryParam = "view=quick-buy";
    link = link.includes("?")
      ? `${link}&${quickBuyTemplateQueryParam}`
      : `${link}?${quickBuyTemplateQueryParam}`;

    const html = await fetch(link).then((res) => res.text());

    this.quickBuyModalHTML = html;
  }

  async openQuickBuyModal() {
    if (!this.quickBuyModalHTML) await this.fetchQuickBuyModalHTML();

    const $modalHTML = document.createElement("div");
    $modalHTML.classList.add("js-invisible", "js-contains-quickbuy");
    $modalHTML.innerHTML = `
      <a href="${this.getAttribute(
        "data-product-url"
      )}" class="js-quickbuy-button"></a>
      ${this.quickBuyModalHTML}
    `;

    this.appendChild($modalHTML);

    setTimeout(() => {
      this.querySelector(".js-quickbuy-button").click();
    }, 100);
  }
}

customElements.define("quick-buy-button", QuickBuyButton);
// End Quick Buy Button
// ---

// ---
// Features
class FeaturesSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
      },
      breakpoints: {
        767: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
      },
    });
  }
}

customElements.define("features-section", FeaturesSection);
// End Features
// ---

// ---
// Main Product
class MainProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initData();
    this.legacyInit();
    this.handleColorSwatches();
    this.watchQtyControls();
    this.handleOptionsSelectors();
    this.divideOptionsToGroups();
    this.deselectSizes();
    this.watchATCButton();
  }

  initData() {
    this.productData = JSON.parse(
      this.querySelector("[data-product-json]").innerHTML
    );
    this.variantData = JSON.parse(
      this.querySelector("[data-current-variant-json]").innerHTML
    );

    window.dispatchEvent(
      new CustomEvent("product:viewed", {
        detail: {
          product: this.productData,
          variant: this.variantData,
        },
      })
    );
  }



  legacyInit() {
    const onLoadWasHandled =
      this.getAttribute("data-on-load-was-handled") === "true";
    if (!onLoadWasHandled) {
      try {
        theme.Product.onSectionLoad(this);
        $(".tabs:not(:has(.tab--active)) a:first").trigger("assess");
      } catch (ex) {
        console.error(ex);
      }
    }

    const thumbNodeList = this.querySelectorAll(".product__thumb-item");
    const productImageNodeList = this.querySelectorAll(".product__image-item");

    const setActive = (index) => {
      thumbNodeList.forEach((thumb, idx) => {
        thumb.classList.toggle("active", idx === index);
      });
      productImageNodeList.forEach((image, idx) => {
        image.classList.toggle("active", idx === index);
      });
    };

    const handleArrowClick = (direction) => {
      const currentImageIndex = Array.from(productImageNodeList).findIndex(
        (image) => image.classList.contains("active")
      );
      const newIndex =
        direction === "prev"
          ? (currentImageIndex - 1 + productImageNodeList.length) %
            productImageNodeList.length
          : (currentImageIndex + 1) % productImageNodeList.length;
      setActive(newIndex);
    };

    const prev = this.querySelector(".product__image-control.prev");
    const next = this.querySelector(".product__image-control.next");

    prev.addEventListener("click", () => handleArrowClick("prev"));
    next.addEventListener("click", () => handleArrowClick("next"));

    thumbNodeList.forEach((item, index) => {
      if (!index) {
        item.classList.add("active");
      }
      item.addEventListener("mouseover", () => setActive(index));
    });

    // Qty Input
    if (window.CustomSelectInstance) {
      new window.CustomSelectInstance(this.querySelector("#qty-proxy"));
    }
  }

  handleColorSwatches() {
    const productHasColorSwatches = !!this.querySelector(
      ".product-color-swatch"
    );
    if (!productHasColorSwatches) return;

    const $swatchLinks = this.querySelectorAll("[data-swatch-product-link]");
    const $swatchProductTitle = this.querySelector(
      "[data-swatch-product-title]"
    );
    let currentTitle = this.getAttribute("data-product-title");
    const currentVariant = this.variantData;

    const updateSwatchProducts = (currentVariant) => {
      $swatchLinks.forEach(($link) => {
        const productData = JSON.parse($link.nextElementSibling.innerHTML);
        if (
          productData.options?.some((type) =>
            currentVariant?.options.includes(type)
          )
        ) {
          let matchedIndex = productData.varaintsOptions.findIndex(
            (options) =>
              currentVariant.options.join("||") === options.join("||")
          );

          if (matchedIndex === -1) {
            matchedIndex = productData.varaintsOptions.findIndex((options) =>
              options.includes(currentVariant.options[2])
            );
          }

          matchedIndex !== -1 &&
            $link.setAttribute("href", productData.varaintsURLs[matchedIndex]);
          $link.removeAttribute("hidden");
        } else {
          // $link.setAttribute("hidden", true);
        }
      });
    };

    updateSwatchProducts(currentVariant);

    $swatchLinks.forEach(($link) => {
      $link.addEventListener("mouseover", () => {
        const rawLabel =
          $link.getAttribute("data-swatch-color") ||
          $link.getAttribute("data-swatch-product-link");
        const label = rawLabel
          ? rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1)
          : "";

        if (label === currentTitle) return;
        currentTitle = label;

        const $group = $link.closest(".product-color-group");
        const $titleEl = $group
          ? $group.querySelector("[data-swatch-product-title]")
          : $swatchProductTitle;

        if ($titleEl) {
          $titleEl.innerHTML = `<span>${label}</span>`;
        }
      });

      $link.addEventListener("mouseleave", () => {
        const $group = $link.closest(".product-color-group");
        const $titleEl = $group
          ? $group.querySelector("[data-swatch-product-title]")
          : $swatchProductTitle;
        const $activeSwatch = ($group || this).querySelector(
          "[data-swatch-product-link].active"
        );

        if ($titleEl) {
          if ($activeSwatch) {
            const rawActive =
              $activeSwatch.getAttribute("data-swatch-color") ||
              $activeSwatch.getAttribute("data-swatch-product-link");
            const activeLabel = rawActive
              ? rawActive.charAt(0).toUpperCase() + rawActive.slice(1)
              : "";
            currentTitle = activeLabel;
            $titleEl.innerHTML = `<span>${activeLabel}</span>`;
          } else {
            currentTitle = "";
            $titleEl.innerHTML = `<span></span>`;
          }
        }
      });
    });

    window.addEventListener("variant:changed", (evt) => {
      const currentVariant = evt.detail.variant;
      updateSwatchProducts(currentVariant);
    });
  }

  watchQtyControls() {
    const $qtyStepBtns = [...this.querySelectorAll(".qty-actual__step")];
    const $qtyInput = this.querySelector(".qty-actual__input");

    $qtyStepBtns.forEach(($qtyStepBtn) => {
      const step = $qtyStepBtn.classList.contains("qty-actual__step--decrease")
        ? -1
        : 1;

      $qtyStepBtn.addEventListener("click", () => {
        let newValue = parseInt($qtyInput.value) + step;
        if (newValue < 1) newValue = 1;
        if (isNaN(newValue)) newValue = 1;

        if ($qtyInput) $qtyInput.value = newValue;
      });
    });
  }

  handleOptionsSelectors() {
    const PRODUCT_SECTION_NAME = this.closest(
      "[id*=shopify-section-]"
    ).id.replace("shopify-section-", "");

    if (!window.pageHTMLs) {
      window.pageHTMLs = {};
    }

    this.fetchPage = async (url, force = false) => {
      if (!force && pageHTMLs[url]) return;
      if (force && pageHTMLs[url]?.hasLoaded === true) return;

      pageHTMLs[url] = { hasLoaded: false };

      const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}sections=${PRODUCT_SECTION_NAME}`);
      const responseJSON = await response.json();
      pageHTMLs[url] = { ...responseJSON, hasLoaded: true };
    };

    this.updatePage = async (url, linkEl) => {
      // Routing logic:
      //   - Same product URL (variant-only change): SPA.
      //   - Cross-product SAME product.type (Range→Range, Tie→Tie, etc.): SPA
      //     — reviews/videos/content blocks are grouped by product.type.
      //   - Cross-product DIFFERENT product.type: full reload so reviews/etc
      //     refresh correctly.
      const currentPath = window.location.pathname;
      let newPath;
      try {
        newPath = new URL(url, window.location.origin).pathname;
      } catch (e) {
        newPath = url;
      }
      if (currentPath !== newPath) {
        const $mainProduct = document.querySelector('main-product[data-raw-product-type]');
        const sourceType = $mainProduct ? ($mainProduct.getAttribute('data-raw-product-type') || '') : '';
        const targetType = linkEl ? (linkEl.getAttribute('data-product-type') || '') : '';
        if (sourceType && targetType && sourceType !== targetType) {
          window.location.href = url;
          return;
        }
      }

      // Save the active tab name and nav scroll position before re-render
      const $activeTab = document.querySelector('.v2-swatch-tabs__tab.is-active');
      const activeTabName = $activeTab ? $activeTab.getAttribute('data-v2-tab') : null;
      const $tabNav = document.querySelector('.v2-swatch-tabs__nav');
      const tabNavScrollLeft = $tabNav ? $tabNav.scrollLeft : 0;

      await this.fetchPage(url, true);

      const selectors = {
        product: ".shopify-section.section-product-template",
      };

      document.querySelector(selectors.product).innerHTML = pageHTMLs[url][PRODUCT_SECTION_NAME];

      // Re-init the explainer video after SPA swap. Two-part:
      //   1. Dispatch resize — makes YT player iframe load & play button appear
      //      (discovered by observation: opening dev tools fires resize which
      //      kicks the theme's debouncedresize handler → _loadThirdPartyApis).
      //   2. Call theme.VideoManager.onSectionLoad(newVideoSection) — wires up
      //      the play button click handler (.video-container__play) and stop
      //      button handler. Without this, play button is visible but inert.
      setTimeout(() => {
        try {
          window.dispatchEvent(new Event('resize'));
          if (window.jQuery) {
            window.jQuery(window).trigger('debouncedresize');
            window.jQuery(window).trigger('resize');
          }
          const videoSection = document
            .querySelector(selectors.product)
            .querySelector('[data-section-type="video"]');
          if (videoSection && window.theme && window.theme.VideoManager &&
              typeof window.theme.VideoManager.onSectionLoad === 'function') {
            window.theme.VideoManager.onSectionLoad(videoSection);
          }
        } catch (e) { /* non-fatal */ }
      }, 150);

      history.pushState({}, "", url);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Restore the active tab if the server rendered a different one
          if (activeTabName) {
            const $newTab = document.querySelector(`.v2-swatch-tabs__tab[data-v2-tab="${CSS.escape(activeTabName)}"]`);
            if ($newTab && !$newTab.classList.contains('is-active')) {
              const $root = $newTab.closest('.v2-swatch-tabs');
              if ($root) {
                $root.querySelectorAll('.v2-swatch-tabs__tab').forEach(function(t) {
                  const active = t.getAttribute('data-v2-tab') === activeTabName;
                  t.classList.toggle('is-active', active);
                  t.setAttribute('aria-selected', String(active));
                });
                $root.querySelectorAll('.v2-swatch-tabs__panel').forEach(function(p) {
                  p.classList.toggle('is-active', p.getAttribute('data-v2-panel') === activeTabName);
                });
              }
            }
          }

          // Hide the nav immediately to prevent visible jump, restore after scroll set
          const $navWrapper = document.querySelector('.v2-swatch-tabs--ties .v2-swatch-tabs__nav-wrapper');
          if ($navWrapper) $navWrapper.style.opacity = '0';

          // Re-init scrollbar on the active panel after layout is complete
          setTimeout(() => {
            const $newTabNav = document.querySelector('.v2-swatch-tabs__nav');
            const $activeNavTab = $newTabNav ? $newTabNav.querySelector('.v2-swatch-tabs__tab.is-active') : null;
            if ($newTabNav && $activeNavTab) {
              const navWidth = $newTabNav.clientWidth;
              const btnLeft = $activeNavTab.offsetLeft;
              const btnWidth = $activeNavTab.offsetWidth;
              const target = btnLeft - (navWidth / 2) + (btnWidth / 2);
              $newTabNav.scrollTo({ left: target, behavior: 'instant' });
            }
            // Re-measure scrollbar for the active panel now that layout is settled
            const $activePanel = document.querySelector('.v2-swatch-tabs__panel.is-active');
            const $btns = $activePanel ? $activePanel.querySelector('.option-selector__btns') : null;
            const $track = $activePanel ? $activePanel.querySelector('.v2-swatch-tabs__panel-scrollbar-track') : null;
            const $thumb = $activePanel ? $activePanel.querySelector('.v2-swatch-tabs__panel-scrollbar-thumb') : null;
            if ($btns && $track && $thumb) {
              const updateThumb = () => {
                const scrollWidth = $btns.scrollWidth;
                const clientWidth = $btns.clientWidth;
                if (scrollWidth <= clientWidth) {
                  $track.style.display = 'none';
                  return;
                }
                $track.style.display = 'block';
                const thumbWidth = Math.max(30, (clientWidth / scrollWidth) * $track.offsetWidth);
                const maxScroll = scrollWidth - clientWidth;
                const maxLeft = $track.offsetWidth - thumbWidth;
                const left = ($btns.scrollLeft / maxScroll) * maxLeft;
                $thumb.style.width = thumbWidth + 'px';
                $thumb.style.left = left + 'px';
              };
              // Remove old handler and attach fresh one so thumb tracks scroll
              if ($btns._v2ScrollHandler) {
                $btns.removeEventListener('scroll', $btns._v2ScrollHandler);
              }
              $btns._v2ScrollHandler = updateThumb;
              $btns.addEventListener('scroll', updateThumb, { passive: true });
              updateThumb();
            }
            // Show nav again
            const $navWrapper = document.querySelector('.v2-swatch-tabs--ties .v2-swatch-tabs__nav-wrapper');
            if ($navWrapper) {
              $navWrapper.style.transition = 'opacity 0.15s ease';
              $navWrapper.style.opacity = '1';
            }
          }, 150);
        });
      });
    };

    const $variantLinkEls = this.querySelectorAll(
      "[data-swatch-product-link], .option-selector__btns a"
    );
    $variantLinkEls.forEach(($variantLinkEl) => {
      let newPageURL = `${$variantLinkEl.href}`;
      let params = new URLSearchParams(window.location.search);

      if (!newPageURL.includes("?")) newPageURL += "?";

      if (params.has("view")) {
        newPageURL = newPageURL + `&view=${params.get("view")}`;
      }

      $variantLinkEl.addEventListener("mouseover", async (e) => {
        this.fetchPage(newPageURL);
      });

      $variantLinkEl.addEventListener("click", async (e) => {
  e.preventDefault();
  this.updatePage($variantLinkEl.href, $variantLinkEl);  // pass element for tab-group check
});
    });
  }

  divideOptionsToGroups() {
    // v2 layout uses always-visible .product-color-group divs — skip tab logic
    if (this.querySelector(".product-color-group")) {
      this.classList.add("has-no-option-grouping");
      return;
    }

    const productType = this.getAttribute("data-product-type");
    const hasSwatchProductsLinks =
      [...this.querySelectorAll("[data-swatch-product-link]")].length > 0;

    switch (true) {
      case productType === "shirts" && hasSwatchProductsLinks: {
        this.divideOptionsToGroupsForShirts();
        break;
      }

      case (productType === "ties" || productType === "polos") && hasSwatchProductsLinks: {
        this.divideOptionsToGroupsForTies();
        break;
      }

      default: {
        this.classList.add("has-no-option-grouping");
        break;
      }
    }
  }

  divideOptionsToGroupsForShirts() {
    const tabs = {
      Pocket: [],
    };
    let activeTab = Object.keys(tabs)[0];

    const $switchBtns = [
      ...this.querySelectorAll("[data-swatch-product-link]"),
    ];
    $switchBtns.forEach(($switchBtn) => {
      const title = $switchBtn.getAttribute("data-swatch-product-link");
      const titleParts = title.split(" - ");
      titleParts.shift();
      const isActiveBtn = $switchBtn.classList.contains("active");

      // console.log(titleParts)
      let targetTabGroup = Object.keys(tabs)[0];
      if (titleParts.length > 1) {
        if (!tabs[titleParts[1]]) {
          tabs[titleParts[1]] = [];
        }

        targetTabGroup = titleParts[1];
      }

      if (isActiveBtn) {
        activeTab = targetTabGroup;
      }

      $switchBtn.setAttribute("data-tab-group", targetTabGroup);
      tabs[targetTabGroup].push($switchBtn);
    });

    $switchBtns.forEach(($switchBtn) => {
      $switchBtn.classList.toggle(
        "is-active-tab-item",
        $switchBtn.getAttribute("data-tab-group") === activeTab
      );
    });

    const $tabsWrapper = document.createElement("div");
    $tabsWrapper.classList.add("product-detail__option-tabs");
    const $tabButtons = [];

    Object.keys(tabs).forEach((tabName) => {
      const $tabButton = document.createElement("button");
      $tabButton.type = "button";
      $tabButton.classList.add("product-detail__option-tab");
      $tabButton.innerText = tabName;
      $tabButton.setAttribute("data-tab-group", tabName);

      $tabButton.classList.toggle("is-active-tab", activeTab === tabName);

      $tabButton.addEventListener("click", () => {
        $switchBtns.forEach(($switchBtn) => {
          const shouldBeVisible =
            $switchBtn.getAttribute("data-tab-group") === tabName;
          $switchBtn.classList.toggle("is-active-tab-item", shouldBeVisible);
        });

        $tabButtons.forEach(($tabBtn) => {
          $tabBtn.classList.toggle("is-active-tab", false);
        });

        $tabButton.classList.toggle("is-active-tab", true);

        tabs[tabName][0].click();
      });

      $tabButton.addEventListener("mouseover", () => {
        this.fetchPage(tabs[tabName][0].href);
      });

      $tabButtons.push($tabButton);
      $tabsWrapper.appendChild($tabButton);
    });

    this.updateGroupDropdown($tabsWrapper, activeTab);
  }

  divideOptionsToGroupsForTies() {
    const tabs = {};
    const groupingDropdownSelected = this.querySelector(".product-details__grouping-dropdown-selected").getAttribute('data-dropdown-grouping-selected')
    let activeTab = Object.keys(tabs)[0] || groupingDropdownSelected;

    const $switchBtns = [
      ...this.querySelectorAll("[data-swatch-product-link]"),
    ];
    $switchBtns.forEach(($switchBtn) => {
      const isActiveBtn = $switchBtn.classList.contains("active");

      let targetTabGroup = $switchBtn.getAttribute("data-tab-group-from-tag");
      let targetTabOrder = +$switchBtn.getAttribute("data-tab-order");

      if (!tabs[targetTabGroup]) {
        tabs[targetTabGroup] = { order: targetTabOrder, btns: [] };
      }

      if (isActiveBtn) {
        activeTab = targetTabGroup;
      }

      $switchBtn.setAttribute("data-tab-group", targetTabGroup);
      tabs[targetTabGroup].btns.push($switchBtn);
    });

    $switchBtns.forEach(($switchBtn) => {
      $switchBtn.classList.toggle(
        "is-active-tab-item",
        $switchBtn.getAttribute("data-tab-group") === activeTab
      );
    });

    const $tabsWrapper = document.createElement("div");
    $tabsWrapper.classList.add("product-detail__option-tabs");
    const $tabButtons = [];

    Object.keys(tabs).forEach((tabName) => {
      const $tabButton = document.createElement("button");
      $tabButton.type = "button";
      $tabButton.style.setProperty("--tab-order", tabs[tabName].order);
      $tabButton.classList.add("product-detail__option-tab");
      $tabButton.innerText = tabName;
      $tabButton.setAttribute("data-tab-group", tabName);

      $tabButton.classList.toggle("is-active-tab", activeTab === tabName);

      $tabButton.addEventListener("click", () => {
        $switchBtns.forEach(($switchBtn) => {
          const shouldBeVisible =
            $switchBtn.getAttribute("data-tab-group") === tabName;
          $switchBtn.classList.toggle("is-active-tab-item", shouldBeVisible);
        });

        $tabButtons.forEach(($tabBtn) => {
          $tabBtn.classList.toggle("is-active-tab", false);
        });

        $tabButton.classList.toggle("is-active-tab", true);

        tabs[tabName].btns[0].click();
      });

      $tabButton.addEventListener("mouseover", () => {
        this.fetchPage(tabs[tabName].btns[0].href);
      });

      $tabButtons.push($tabButton);
      $tabsWrapper.appendChild($tabButton);
    });

    this.updateGroupDropdown($tabsWrapper, activeTab);
  }

  updateGroupDropdown($tabsWrapper, activeTab) {
    if ($tabsWrapper.childElementCount <= 1) return;

    this.querySelector(".product-details__grouping").classList.add("show");
    if(activeTab) {
      this.querySelector(".product-details__grouping-dropdown-selected").prepend(
        activeTab
      );
    }

    this.querySelector(
      ".product-details__grouping-dropdown-selected"
    ).addEventListener("click", () => {
      this.querySelector(
        ".product-details__grouping-dropdown"
      ).classList.toggle("open");
    });

    this.querySelector(
      ".product-details__grouping-dropdown-items"
    ).insertAdjacentElement("afterbegin", $tabsWrapper);
  }

  deselectSizes() {
    const $selectedSizeOption = this.querySelector(
      `[data-option-name="size"] [type="radio"]:is([checked], :checked)`
    );
    if ($selectedSizeOption) {
      $selectedSizeOption.checked = false;
      $selectedSizeOption.removeAttribute("checked");
      this.dispatchEvent(new CustomEvent("variantChange"));
    }
  }

  watchATCButton() {
    const $atcBtn = this.querySelector("[data-add-to-cart]");
    $atcBtn.addEventListener("click", (e) => {
      const hasNotSelectedOption =
        this.getAttribute("data-has-not-selected-option") === "true";
      if (hasNotSelectedOption) {
        e.preventDefault();
        this.setAttribute("data-show-not-selected-option-error", true);
      }
    });
  }
}

customElements.define("main-product", MainProduct);
// End Main Product
// ---

// ---
// FAQ 2.0
class Faq2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.watchQAitems();
  }

  watchQAitems() {
    const $qaItems = [...this.querySelectorAll("[data-qa-item]")];
    $qaItems.forEach(($qaItem) => {
      $qaItem.addEventListener("click", () => {
        $qaItems.forEach(($qi) => {
          if ($qi.id === $qaItem.id) return;
          $qi.checked = false;
        });
      });
    });
  }
}

customElements.define("faq-2", Faq2);
// End FAQ 2.0
// ---

// ---
// Size Guide 2.0
class SizeGuide2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.id = this.getAttribute("data-id");
    const mode = this.getAttribute("data-mode");

    if (mode === "expanded") {
      this.handleModalContent(
        this.querySelector(".size-guide-2__modal-wrapper-static")
      );
    } else {
      this.handleModal();
    }
  }

  handleModal() {
    const openModal = () => {
      const $modalTemplate = this.querySelector(
        "[data-modal-template]"
      ).content.cloneNode(true);

      const $modal = document.createElement("dialog");
      $modal.setAttribute("open", "");
      $modal.classList.add("size-guide-2__modal-wrapper");
      $modal.append($modalTemplate);

      document.body.prepend($modal);

      const $closeModalBtn = $modal.querySelector("[data-modal-close]");
      $closeModalBtn.addEventListener("click", () => {
        $modal.classList.add("size-guide-2__modal-wrapper--hiding");

        setTimeout(() => {
          $modal.remove();
        }, 300);
      });

      this.handleModalContent($modal);
    };

    const $openModalBtn = this.querySelector("[data-modal-open]");
    $openModalBtn.addEventListener("click", () => openModal());
  }

  handleModalContent($modal) {
    const enableContentItem = (state, $contentItems) => {
      const optionNames = Object.keys(state);

      $contentItems.forEach(($contentItem) => {
        const matchesTheState = optionNames.every((optionName) => {
          return (
            $contentItem.getAttribute(`data-${optionName}`) ===
            state[optionName]
          );
        });

        $contentItem.classList.toggle("active", matchesTheState);
      });
    };

    const state = {
      [`${this.id}type`]: "",
      [`${this.id}fit`]: "",
      [`${this.id}size`]: "",
    };

    const $contentItems = $modal.querySelectorAll("[data-modal-content-item]");

    // watch radio button clicks
    const $optionRadios = $modal.querySelectorAll("[data-option-radio]");
    $optionRadios.forEach(($optionRadio) => {
      $optionRadio.addEventListener("click", () => {
        const name = $optionRadio.name;
        const value = $optionRadio.value;
        state[name] = value;

        enableContentItem(state, $contentItems);
      });
    });

    // enable first found content item
    Object.keys(state).forEach((optionName) => {
      const $radioButton = $modal.querySelector(`[name="${optionName}"]`);
      if ($radioButton) {
        $radioButton.click();
      }
    });
  }
}

customElements.define("size-guide-2", SizeGuide2);
// End Size Guide 2.0
// ---

// ---
// ---
// Klaviyo BIS Element
const KLAVIYO_BIS_ELEMENT_ID = "klaviyo-bis";

const klaviyoBISattributes = {
  body: `data-${KLAVIYO_BIS_ELEMENT_ID}-body`,
  close: `data-${KLAVIYO_BIS_ELEMENT_ID}-close`,
  open: `data-${KLAVIYO_BIS_ELEMENT_ID}-open`,
  requestUrl: `data-${KLAVIYO_BIS_ELEMENT_ID}-url`,
  responseMessage: `data-${KLAVIYO_BIS_ELEMENT_ID}-response`,
};

class KlaviyoBIS extends HTMLElement {
  constructor() {
    super();
    this.$closeElements = this.querySelectorAll(
      `[${klaviyoBISattributes.close}]`
    );
    this.$formElement = this.querySelector("form");
    if (!this.$formElement) throw new Error("[KlaviyoBIS] Form not found");
  }

  connectedCallback() {
    console.log("KlaviyoBIS connectedCallback");
    this.#setCloseEvent();
    this.#submitForm();
    document.addEventListener(
      "click",
      (event) => {
        this.#setOpenEvent(event);
      },
      false
    );
  }

  async #setOpenEvent(event) {
    const $openElement = event.target.closest(`[${klaviyoBISattributes.open}]`);
    if (!$openElement) return;

    event.preventDefault();
    this.#toggle(true);
    this.#loading(true);
    const form = $openElement.closest("form");
    const requestURL = $openElement.getAttribute(
      klaviyoBISattributes.requestUrl
    );
    const selectedVariantId = form?.querySelector("[name='id']")?.value || 0;

    const url = `${requestURL}${requestURL.indexOf("?") > -1 ? "&" : "?"}${
      parseInt(selectedVariantId) > 0 ? `variant=${selectedVariantId}&` : ""
    }section_id=${KLAVIYO_BIS_ELEMENT_ID}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("[KlaviyoBIS] Response error");
      // this.#toggle(true);
      const html = await response.text();
      this.#replaceHTML(html);
      this.#loading(false);
    } catch (error) {
      throw new Error(`[KlaviyoBIS] ${error}`);
    }
  }

  #replaceHTML(html) {
    const newDocument = new DOMParser().parseFromString(html, "text/html");
    const $newElement = newDocument.querySelector(
      `${KLAVIYO_BIS_ELEMENT_ID}${this.id ? "#" + this.id : ""}`
    );

    if (!$newElement) throw new Error("[KlaviyoBIS] Element not found");
    this.querySelector(`[${klaviyoBISattributes.body}]`).innerHTML =
      $newElement.querySelector(`[${klaviyoBISattributes.body}]`).innerHTML;
  }

  async #submitForm() {
    this.$formElement.addEventListener("submit", async (event) => {
      event.preventDefault();
      this.#reset();
      this.#loading(true);
      try {
        const formData = new FormData(this.$formElement);
        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: formData.get("email"),
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${formData.get("variant")}`,
                },
              },
            },
          },
        };
        const response = await fetch(this.$formElement.action, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            revision: "2023-09-15",
          },
          body: JSON.stringify(payload),
        });

        if (response?.status === 202) {
          this.#success(true);
        } else {
          this.#error(true);
        }

        this.#loading(false);
      } catch (error) {
        this.#loading(false);
        throw new Error(`[KlaviyoBIS] ${error}`);
      }
    });
  }

  #setCloseEvent() {
    const _self = this;
    document.addEventListener("keyup", (event) => {
      if (event.code?.toUpperCase() === "ESCAPE") _self.#toggle(false);
    });
    if (!this.$closeElements || !this.$closeElements.length)
      return console.warn("[KlaviyoBIS] Close element not found");

    this.$closeElements.forEach((element) =>
      element.addEventListener("click", (e) => {
        e.preventDefault();
        _self.#toggle(false);
      })
    );
  }

  #toggle(open) {
    this.#reset();
    open ? this.setAttribute("open", "") : this.removeAttribute("open");
  }

  #loading(activate) {
    activate
      ? this.setAttribute("loading", "")
      : this.removeAttribute("loading");
  }

  #success(activate) {
    activate
      ? this.setAttribute("success", "")
      : this.removeAttribute("success");
  }

  #error(activate) {
    activate ? this.setAttribute("error", "") : this.removeAttribute("error");
  }

  #reset() {
    this.#error(false);
    this.#success(false);
    this.#loading(false);
  }
}
customElements.define(KLAVIYO_BIS_ELEMENT_ID, KlaviyoBIS);
// End Klaviyo BIS Element
// ---
// ---//PRODUCT THUMBNAILS
class ProductThumbnails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.$wrapper = this.querySelector("[data-product-thumbnails-wrapper]");

    this.initOverflow();
    this.initControls();
  }

  initControls() {
    this.querySelectorAll("[data-product-thumbnails-nav]").forEach(
      ($control) => {
        $control.addEventListener("click", () => {
          if ($control.getAttribute("data-product-thumbnails-nav") === "top") {
            this.$wrapper.scrollTop -= 80;
          } else {
            this.$wrapper.scrollTop += 80;
          }
        });
      }
    );
  }

  initOverflow() {
    if (!this.checkOverflow(this.$wrapper)) return;

    this.classList.add("thumbs-overflowing");

    this.$wrapper.addEventListener("scroll", (evt) => {
      this.classList.toggle("thumbs-start", this.$wrapper.scrollTop === 0);
      this.classList.toggle(
        "thumbs-end",
        this.$wrapper.scrollTop + this.$wrapper.clientHeight ===
          this.$wrapper.scrollHeight
      );
    });
  }

  checkOverflow($el) {
    return $el.clientHeight < $el.scrollHeight;
  }
}

customElements.define("product-thumbnails", ProductThumbnails);
// END PRODUCT THUMBNAILS

//PRODUCT COLORS COUNT
class ProductColorsCount extends HTMLElement {
  _abortController;

  constructor() {
    super();
  }

  connectedCallback() {
    // if (this.getAttribute("product-title").split("-").length ) return;

    this._populate();
  }

  disconnectedCallback() {
    if (this._abortController) {
      this._abortController.abort();
    }
  }

  _populate() {
    let fetchURL = this.getAttribute("href");
    fetchURL += "?section_id=product-colors-count";

    this._abortController = new AbortController();

    fetch(fetchURL, {
      signal: this._abortController.signal,
    })
      .then((response) => {
        if (!response.ok)
          throw new Error(
            `[${ELEMENT_NAME}] [Response error from the "${response.url}" URL]`
          );
        return response.text();
      })
      .then((text) => {
        this.innerHTML = text;
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        throw error;
      });
  }
}

customElements.define("product-colors-count", ProductColorsCount);
//END OF PRODUCT COLORS COUNT

class LazyVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const $video = entry.target;
          if (entry.isIntersecting && $video.play) {
            $video.setAttribute("poster", $video.getAttribute("data-poster"));
            $video.play();
          }
        });
      },
      {
        rootMargin: "-100px",
      }
    );

    this.querySelectorAll("[data-lazy-video]").forEach((video) => {
      observer.observe(video);
    });
  }
}

customElements.define("lazy-video", LazyVideo);

class CountrySpecific extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.updateVisibility();
  }

  async updateVisibility() {
    try {
      const location = await this.getVisitorLocation();

      if (this.allowedCountries.includes(location?.country)) {
        this.style.display = "block";
      }
    } catch (error) {
      console.warn(error);
    }
  }

  async getVisitorLocation() {
    const response = await fetch("https://ipinfo.io/json");
    const data = await response.json();
    return data;
  }

  init() {
    this.allowedCountries = this.getAttribute("allowed-countries").split(",");
    this.style.display = "none";
  }
}

customElements.define("country-specific", CountrySpecific);

class SizeMeasurements extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();

    this.processingEvent = false;
    this.variant = null;
    this.product = null;
  }

  init() {
    window.addEventListener("cart-state-updated", async (evt) => {
      if (
        !evt.detail.allOptionsSelected ||
        this.variant?.id === evt.detail?.variant?.id
      )
        return;

      this.variant = evt.detail?.variant;
      this.product = evt.detail?.product;
      this.processEvent();
    });
  }

  show() {
    this.classList.add("size-measurements--show")
  }

  hide() {
    this.classList.remove("size-measurements--show")
  }

  processEvent() {
    this.hide();

    try {
      const fit = this.getProductFit();

      const $table = document
        .querySelector("size-guide-2 [data-modal-template]")
        ?.content?.querySelector(`[data-id_1fit="${fit}"][data-id_1size="inch"]`);

      if (!$table) return;

      const tableData = this.tableToJSON($table);
      const transformedData = this.transformData(tableData);

      if(!transformedData) return;

      this.fillData(transformedData);

      this.show();
    } catch (error) {
      console.warn(error)
      this.hide();
    }
  }

  fillData(data) {
    const attr = "data-measures-item"
    console.log(data);
    this.querySelectorAll(`[${attr}]`).forEach($item => {
      const key = $item.getAttribute(attr);
      const value = data[key];

      if(value) {
        $item.removeAttribute("hidden")
        $item.querySelector("span").textContent = value
      } else {
        $item.setAttribute("hidden")
      }
    })
  }

  transformData(data) {
    const sizeOptionIndex = this.product?.options?.findIndex(
      (opt) => opt.toLowerCase() === "size"
    );

    if (sizeOptionIndex === -1 || !data) return null;

    const size = this.variant?.options?.[sizeOptionIndex];

    const matchedData = data.find((row) => row?.Size.startsWith(size));

    if (!matchedData) return null;

    return {
      fitSizes: `${matchedData["Collar"]}/${matchedData["Sleeve"]}`,
      chest: matchedData["Chest"],
      waist: matchedData["Waist"],
      length: matchedData["Length"],
    };
  }

  getProductFit() {
    const isTall = !!this.product?.title?.toLowerCase()?.includes("tall");
    const isKids = !!this.product?.title?.toLowerCase()?.includes("kid");
    [];

    if (isKids) return "youth";

    const fitOptionIndex = this.product?.options?.findIndex(
      (option) => option.toLowerCase() === "fit"
    );

    const fit = this.variant?.options?.[fitOptionIndex];

    if (isTall) return `tall-${fit.toLowerCase()}`;

    return fit.toLowerCase();
  }

  tableToJSON(table) {
    const headers = [];
    const data = [];

    if (!table) {
      console.error("Provide table");
      return null;
    }

    // Extract headers
    const headerCells = table.querySelectorAll("thead th");
    headerCells.forEach((headerCell) => {
      headers.push(headerCell.textContent.trim());
    });

    // Extract rows
    const rows = table.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const rowData = {};
      const cells = row.querySelectorAll("td");

      cells.forEach((cell, index) => {
        const header = headers[index] || `Column${index + 1}`;
        rowData[header] = cell.textContent.trim();
      });

      data.push(rowData);
    });

    return data;
  }
}

customElements.define("size-measurements", SizeMeasurements);